import { render, staticRenderFns } from "./HchospitalizacionDesktop.vue?vue&type=template&id=4c46dc4d&scoped=true"
import script from "./HchospitalizacionDesktop.vue?vue&type=script&lang=js"
export * from "./HchospitalizacionDesktop.vue?vue&type=script&lang=js"
import style0 from "./HchospitalizacionDesktop.vue?vue&type=style&index=0&id=4c46dc4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c46dc4d",
  null
  
)

export default component.exports